import { Link } from 'react-router-dom';

export default function SeoNav() {
  return (
    <nav className="border-b border-gray-100 dark:border-gray-800 px-6 py-3 flex items-center justify-between">
      <Link to="/" className="flex items-center">
        <img src="/2.png" alt="Invilic" className="h-8 w-auto" />
      </Link>
      <div className="flex items-center gap-4">
        <Link
          to="/"
          className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors hidden sm:block"
        >
          All invoice types
        </Link>
        <Link
          to="/blog"
          className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors hidden sm:block"
        >
          Blog
        </Link>
        <Link
          to="/create"
          className="text-sm font-semibold bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors"
        >
          Create Invoice
        </Link>
      </div>
    </nav>
  );
}
